import type { BusyWatcher } from "@frui.ts/screens";

export const globalBusyWatcher = Symbol("GLOBAL_BUSY_WATCHER");

const censor = (censor: any) => {
  let i = 0;

  return function (key: any, value: any) {
    if (i !== 0 && typeof censor === "object" && typeof value === "object" && censor === value) {
      return "[Circular]";
    }

    if (i >= 29) {
      // seems to be a harded maximum of 30 serialized objects?
      return "[Unknown]";
    }

    ++i; // so we know we aren't using the original object anymore

    return value;
  };
};

export function busyIdentificator(args: any[]) {
  if (args.length === 0) {
    return globalBusyWatcher;
  } else {
    return JSON.stringify(args, censor(args));
  }
}

/*
 Similiar to Frui.ts wathBusy decorator
 - https://github.com/eManPrague/frui.ts/blob/develop/packages/screens/src/structure/busyWatcher.ts
 - adds support to generate busyIdentificator based on method arguments
 */
export function watchBusy(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
  const originalFunction = descriptor.value;

  descriptor.value = function (this: { busyWatcher?: BusyWatcher }, ...args: any[]) {
    const ticket = this.busyWatcher?.getBusyTicket(busyIdentificator(args));
    const result = originalFunction.apply(this, args);

    if (ticket) {
      if (result?.then && typeof result.then === "function") {
        result.then(ticket, (error: any) => {
          console.error(error);
          ticket();
        });
      } else {
        ticket();
      }
    }

    return result;
  };
}
